// Ambiguous characters (0/O, 1/l/I) are left out because the password is read out or copied by hand.
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'

export const generatePassword = (length = 12): string => {
  const values = crypto.getRandomValues(new Uint32Array(length))
  return Array.from(values, (value) => ALPHABET[value % ALPHABET.length]).join(
    '',
  )
}
